export default __webpack_public_path__ + "assets/images/110424c8bc6892d92d3092bfb4bbedb8-signature-tutorial-first-page.gif";